import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';


const api = '/api/site/players';

const ListPlayers = () => {
  const filter = {};

  return (
    <ListResource
    {...{
      // searchable: true,
      api,
      sort: { page: 1, location: 1 },
      filter,
      actions: {
        fileExport: true,
        // fileImport: { url: '/api/site/players/files' },
      },
      cols: [
        { key: 'name', sortable: true, children: 'Name' },
        { key: 'stableName', sortable: true, children: 'Stable' },
        {
          key: 'active',
          getter(v) {
            return (
              <FA icon={v ? faEye : faEyeSlash} />
            );
          },
        },
        { key: 'address' },
        { key: 'gxeEarned', children: 'GXE Earned' },
      ],
      // ctrls: [
      //   <select
      //     className="custom-select"
      //     key={0}
      //     value={location}
      //     onChange={(e) => setLocation(e.target.value)}
      //   >
      //     <option value="">Select Attribute</option>
      //     {attr.map((a) => (
      //       <option key={a} value={a}>{a}</option>
      //     ))}
      //   </select>,
      // ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
  );
};

export default ListPlayers;
